import styled, { css } from "styled-components";

export const Step = styled.div`
  display: flex;
  gap: 13px;
  align-items: flex-start;
`;

export const StepRail = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StepCircle = styled.div<{ $current?: boolean }>`
  width: 26px;
  height: 26px;
  border-radius: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: ${(p) => (p.$current ? p.theme.tokens.gradients.accent : p.theme.tokens.colors.softTeal)};
  color: ${(p) => (p.$current ? "#fff" : p.theme.tokens.colors.teal)};
`;

export const Connector = styled.div`
  width: 2.5px;
  flex: 1;
  min-height: 24px;
  background: ${(p) => p.theme.tokens.colors.line};
  border-radius: 2px;
  margin: 2px 0;
`;

export const StepBody = styled.div`
  padding-top: 2px;
  padding-bottom: 18px;
`;

export const StepLabel = styled.div<{ $current?: boolean }>`
  font-weight: 800;
  font-size: 14.5px;
  font-family: ${(p) => p.theme.tokens.font.family};
  ${(p) =>
    p.$current
      ? css`color: ${p.theme.tokens.colors.ink};`
      : css`color: ${p.theme.tokens.colors.muted};`}
`;

export const StepDate = styled.div`
  font-size: 12px;
  color: ${(p) => p.theme.tokens.colors.muted};
  font-family: ${(p) => p.theme.tokens.font.family};
  margin-top: 1px;
`;
